import { useId } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RUFlag = ({ sx, ...props }: SvgIconProps) => {
  const clipId = useId();

  return (
    <SvgIcon
      viewBox='0 0 25 25'
      fill='none'
      sx={{ width: '24px', height: '24px', fill: 'none', ...sx }}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M-2.60625 0.5H28.1001C29.1438 0.5 29.9938 1.35 29.9938 2.39375V12.5H-4.5V2.39375C-4.5 1.35 -3.65 0.5 -2.60625 0.5Z'
          fill='white'
        />
        <path
          d='M-4.5 12.5H30.0001V22.6063C30.0001 23.65 29.1501 24.5 28.1063 24.5H-2.60625C-3.65 24.5 -4.5 23.6438 -4.5 22.6063V12.5Z'
          fill='#D52B1E'
        />
        <path d='M-4.5 8.50012H30.0001V16.5001H-4.5V8.50012Z' fill='#0039A6' />
      </g>
      <path
        d='M12.5 0.25C19.2655 0.25 24.75 5.73451 24.75 12.5C24.75 19.2655 19.2655 24.75 12.5 24.75C5.73451 24.75 0.25 19.2655 0.25 12.5C0.25 5.73451 5.73451 0.25 12.5 0.25Z'
        fill='none'
        stroke='#DFE1E1'
        strokeWidth='0.5'
      />
      <defs>
        <clipPath id={clipId}>
          <path
            d='M0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default RUFlag;
